import { hasCURAccessForAction } from 'common/services/permissions/commonPermissionService';
import { FeatureTypesWithCurs, FeaturePrivilegesWithCurs } from 'common/services/permissions/typings';
import { ContextState } from 'author/src/store/context/reducer';
import { ContentTypes, workspaceID } from '../../store/common/constants';
import { getUrlParam } from '../url/urlUtil';

export const isQuestionMode = () => getUrlParam('mode') === 'question';
export const isOneWorkspaceMode = () => getUrlParam('oneWorkspaceMode') === 'true';
export const isFocusView = () => getUrlParam('focusView') === 'true';
// True when Author is embedded purely to show the Question Set Summary
// without any content item selected.
export const isQuestionSetSummaryWorkspace = () => getUrlParam('workspaceId') === workspaceID.QUESTION_SET_SUMMARY;
export const isPrintViewParams = () => getUrlParam('printMode') === 'true';
export const printWithoutFeatureHeader = () => getUrlParam('printWithoutFeatureHeader') === 'true';
export const isOverlayTesting = () => getUrlParam('testing') === 'overlayTesting';
export const isPreviousDAKTesting = () => getUrlParam('testing') === 'isPreviousDAKTesting';
export const isViewMarksWithRubric = () => getUrlParam('viewMarksWithRubric') === 'true';
export const isViewAsStudent = () => getUrlParam('viewAsStudent') === 'true';
export const isQuestionReview = () => getUrlParam('contentType') !== ContentTypes.SECTION && isOneWorkspaceMode();
export const isQuestionSet = () => getUrlParam('contentType') === ContentTypes.QUESTION_SET;
export const isQuestion = () => getUrlParam('contentType') === ContentTypes.QUESTION;
export const isSection = () => getUrlParam('contentType') === ContentTypes.SECTION;
export const isQuestionSetTemplate = () => isQuestionSet() && getUrlParam('isTemplate') === 'true';
export const isQuestionTemplate = () => isQuestionMode() && getUrlParam('isTemplate') === 'true';
export const isContentBlockTemplate = () => isSection() && getUrlParam('isTemplate') === 'true';

export const hasEditAccessForCurrentContent = (context: ContextState): boolean => {
    if (!context?.currentItemContext) {
        return false;
    }
    const { CONTENT_BLOCK_EDIT } = FeaturePrivilegesWithCurs[FeatureTypesWithCurs.CONTENT_BLOCK_EDIT];
    return hasCURAccessForAction(FeatureTypesWithCurs.CONTENT_BLOCK_EDIT, CONTENT_BLOCK_EDIT);
};

const sharedUtils = {
    isQuestionMode,
    isOneWorkspaceMode,
    isFocusView,
    isQuestionSetSummaryWorkspace,
    isPrintViewParams,
    printWithoutFeatureHeader,
    isOverlayTesting,
    isViewMarksWithRubric,
    isViewAsStudent,
    isQuestionReview,
    isQuestionSet,
    isQuestion,
    isSection,
    isQuestionSetTemplate,
    isQuestionTemplate,
    isContentBlockTemplate,
    hasEditAccessForCurrentContent,
};

export default sharedUtils;
